var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-box"},[_c('ul',_vm._l((_vm.userMenu),function(item){return _c('li',{class:{'active': item.active === 1},on:{"click":function($event){return _vm.goMenu(item)}}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }